import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import { formatTime } from '@/lib/tracks';

/**
 * Stopwatch — counts UP from `startISO`.
 * Colour ramps: <10 min green, <20 min amber, >=20 min red (as a soft nudge).
 */
export function Stopwatch({ startISO }) {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!startISO) return;
    const start = new Date(startISO).getTime();
    const tick = () => {
      const now = Date.now();
      setElapsed(Math.max(0, Math.floor((now - start) / 1000)));
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [startISO]);

  let cls = 'text-[hsl(var(--timer-safe))]';
  if (elapsed >= 20 * 60) cls = 'text-[hsl(var(--timer-danger))]';
  else if (elapsed >= 10 * 60) cls = 'text-[hsl(var(--timer-warn))]';

  return (
    <div
      className="inline-flex items-center gap-2 rounded-full border bg-card px-3 py-1.5 shadow-sm"
      data-testid="exam-stopwatch"
      aria-live="polite"
      title="Elapsed time"
    >
      <Clock className={`h-4 w-4 ${cls}`} />
      <span className={`font-mono-ui text-sm tabular-nums sm:text-base ${cls}`}>{formatTime(elapsed)}</span>
    </div>
  );
}

// Back-compat: keep old Timer export as an alias so existing imports keep working.
export const Timer = Stopwatch;
